/**
 * @generated SignedSource<<8a4e5308f78657bb0d812f8d141c6f18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BrowseChannelsModalQuery$variables = {
  search?: string | null;
};
export type BrowseChannelsModalQuery$data = {
  readonly viewer: {
    readonly autoPublishRecordingSettings: {
      readonly enabled: boolean;
      readonly externalRecordingsChannel: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly internalRecordingsChannel: {
        readonly id: string;
      } | null;
    } | null;
    readonly channels: ReadonlyArray<{
      readonly activeSmartTrackers: ReadonlyArray<{
        readonly name: string;
        readonly triggerPhrasesOrWords: ReadonlyArray<string>;
      }>;
      readonly description: string | null;
      readonly id: string;
      readonly isMember: boolean;
      readonly isPrivate: boolean;
      readonly isWorkspaceWide: boolean;
      readonly lastPostedAt: string | null;
      readonly members: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      }>;
      readonly name: string;
      readonly postsCount: number;
    }>;
  };
};
export type BrowseChannelsModalQuery = {
  response: BrowseChannelsModalQuery$data;
  variables: BrowseChannelsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "excludePersonal",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWorkspaceWide",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastPostedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postsCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "triggerPhrasesOrWords",
  "storageKey": null
},
v12 = [
  (v2/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "UserRecordingAutoPublishSettings",
  "kind": "LinkedField",
  "name": "autoPublishRecordingSettings",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "externalRecordingsChannel",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "internalRecordingsChannel",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrowseChannelsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channels",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SmartTracker",
                "kind": "LinkedField",
                "name": "activeSmartTrackers",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrowseChannelsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channels",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SmartTracker",
                "kind": "LinkedField",
                "name": "activeSmartTrackers",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v11/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a1fd2758ed7aa6b9fdb1c29e8eccf58",
    "id": null,
    "metadata": {},
    "name": "BrowseChannelsModalQuery",
    "operationKind": "query",
    "text": "query BrowseChannelsModalQuery(\n  $search: String\n) {\n  viewer {\n    channels(excludePersonal: true, search: $search) {\n      id\n      name\n      description\n      isMember\n      isPrivate\n      isWorkspaceWide\n      lastPostedAt\n      postsCount\n      members {\n        id\n        email\n        fullName\n        image\n      }\n      activeSmartTrackers {\n        name\n        triggerPhrasesOrWords\n        id\n      }\n    }\n    autoPublishRecordingSettings {\n      id\n      enabled\n      externalRecordingsChannel {\n        id\n      }\n      internalRecordingsChannel {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f076af307883cbd7519cbaec36d9369a";

export default node;
